export const ROWS_PER_PAGE_DEFAULT = [10, 15, 50, 100]

export const propsInputNumberCurrency = {
  mode: 'currency',
  currency: 'EUR',
  locale: 'de-DE',
  minFractionDigits: 0,
  maxFractionDigits: 3,
}
